import { render } from "./footer-web.vue?vue&type=template&id=71eb0eaa&scoped=true"
import script from "./footer-web.vue?vue&type=script&lang=js"
export * from "./footer-web.vue?vue&type=script&lang=js"

import "./footer-web.vue?vue&type=style&index=0&id=71eb0eaa&scoped=true&lang=scss"
import "./footer-web.vue?vue&type=style&index=1&id=71eb0eaa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71eb0eaa"]])

export default __exports__